import { Component } from '@angular/core';

@Component({
  selector: 'app-cloud-upload-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './cloud-upload-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class CloudUploadIconComponent {}
